export default __webpack_public_path__ + "static/media/ResinPrinterImg.d18ce650.jpg";